import { routes } from "constants/routes";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { RootState } from "store";

export default function ProtectedRoute() {
  const { userToken } = useSelector((state: RootState) => state.authState);

  if (!userToken) {
    return <Navigate to={routes.SIGNIN} replace />;
  } else {
    return <Outlet />;
  }
}
